import defaultState from './defaultState';

export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_FILTERS = 'SET_FILTERS';

export default {
  /**
     * Clear state.
     *
     * @param {Object} state - Entity state.
     */
  [CLEAR_STATE]: (state) => {
    Object.assign(state, defaultState());
  },

  /**
     * Save list of transaction logs
     *
     * @param {Object} state - Entity state.
     * @param {{ items: Array, totalItems: number }} data - Entity data to set
     */
  [SET_ITEMS]: (state, { items, totalItems }) => {
    state.items = items;
    state.total = totalItems;
  },

  /**
     * Save entity pagination.
     *
     * @param {Object} state - Entities state.
     * @param {Object} pagination - Entities pagination.
     */
  [SET_PAGINATION]: (state, pagination) => {
    state.pagination = pagination;
  },

  /**
     * Save entity pagination.
     *
     * @param {Object} state - Entities state.
     * @param {Object} filters - Filtering data.
     */
  [SET_FILTERS]: (state, filters) => {
    state.filters = filters;
  },
};
